export default "__VITE_ASSET__C5cGqkir__"